
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15.32 20"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M14.8 14.85l-4.95 4.63-9.23.2V.67H14.8v14.18z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M14.8 14.85l-4.95 4.63-.13-1.79.06-2.55 2.74-.26 2.28-.03z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M14.84 0H.48A.47.47 0 000 .48v19a.47.47 0 00.48.52h9.25a.44.44 0 00.32-.13l5.09-4.63a.46.46 0 00.16-.35V.48a.48.48 0 00-.46-.48zM9.25 14.88V19H1V1h13.4v13.4H9.73a.48.48 0 00-.48.48zm4.35.48l-3.39 3.08v-3.08z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M2.95 4.34h9.42v.96H2.95zM2.95 6.58h9.42v.96H2.95zM2.95 8.85h9.42v.96H2.95z"}})])])])
          )
        }
      }
    